import KeenSlider from 'keen-slider';
// Replaced SCSS module import with plain JS variables for build compatibility
const variables = {
  // Breakpoints in px
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1920,
  menu: 992,
  // Spacers in px
  spacer4: 24,
};

function getWrapper(slider) {
  const region = slider.container.closest('.keen-slider-region');
  if (!region) {
    console.error('Keen Slider Region (wrapper) not found');
  }
  return region;
}
window.keen = {
  KeenSlider,
  minBreakpoint: (name) => {
    if (!variables[name]) {
      console.error('Breakpoint not found:', name);
    }
    return '(min-width: ' + variables[name] + 'px)';
  },
  gridSpacing: parseInt(variables.spacer4),
  Arrows: (slider) => {
    const wrapper = getWrapper(slider);
    if (!wrapper) return;
    const arrows = wrapper.querySelector('.keen-slider__arrows');
    if (!arrows) return;
    const forceShowArrows = !!(slider && slider.container && slider.container.classList && slider.container.classList.contains('js-progress-bar-keen-slider'));

    const arrowLeft = arrows.querySelector('.slider-button--prev');
    const arrowRight = arrows.querySelector('.slider-button--next');
    if (arrowLeft) {
      arrowLeft.addEventListener('click', () => {
        if (!slider.track || !slider.track.details) return;
        slider.prev();
      });
    }
    if (arrowRight) {
      arrowRight.addEventListener('click', () => {
        if (!slider.track || !slider.track.details) return;
        slider.next();
      });
    }

    const updateClasses = () => {
      if (!slider.track || !slider.track.details) return;
      if (forceShowArrows) {
        arrows.classList.remove('d-none');
      } else {
        const overflow =
          slider.track.details.slides.length > slider.options.slides.perView;
        const isDesktop = window.matchMedia(window.keen.minBreakpoint('md')).matches;
        if (!overflow || !isDesktop) {
          arrows.classList.add('d-none');
        } else {
          arrows.classList.remove('d-none');
        }
      }
      if (slider.options.loop) return;
      const slide = slider.track.details.rel;
      if (arrowLeft) {
        slide === slider.track.details.minIdx
          ? arrowLeft.classList.add('slider-button--disabled')
          : arrowLeft.classList.remove('slider-button--disabled');
      }
      if (arrowRight) {
        slide === slider.track.details.maxIdx
          ? arrowRight.classList.add('slider-button--disabled')
          : arrowRight.classList.remove('slider-button--disabled');
      }
    };
    slider.on('created', updateClasses);
    slider.on('optionsChanged', updateClasses);
    slider.on('slideChanged', updateClasses);
  },
  Bullets: (slider) => {
    const wrapper = getWrapper(slider);
    if (!wrapper) return;
    const bulletsList = wrapper.querySelector('.keen-slider__bullets-list');
    if (!bulletsList) return;
    const bullets = bulletsList.querySelectorAll('.keen-slider__bullet');
    bullets.forEach((bullet, idx) => {
      bullet.addEventListener('click', () => slider.moveToIdx(idx));
    });

    const bulletsControl = wrapper.querySelector('.keen-slider__bullets-control');
    if (bulletsControl) {
      const playIcon = bulletsControl.dataset.playIcon;
      const pauseIcon = bulletsControl.dataset.pauseIcon;
      const playText = bulletsControl.dataset.playText;
      const pauseText = bulletsControl.dataset.pauseText;

      const updatePauseButton = () => {
        if (slider.paused) {
          bulletsControl.classList.remove(pauseIcon);
          bulletsControl.classList.add(playIcon);
          bulletsControl.querySelector('span').textContent = playText;
        } else {
          bulletsControl.classList.add(pauseIcon);
          bulletsControl.classList.remove(playIcon);
          bulletsControl.querySelector('span').textContent = pauseText;
        }
      }

      bulletsControl.addEventListener('click', () => {
        if (slider.paused) {
          slider.play();
        } else {
          slider.pause();
        }
      });
      slider.on('pause', updatePauseButton);
      slider.on('play', updatePauseButton);
    }
    const updateClasses = () => {
      var slide = slider.track.details.rel;
      bullets.forEach(function (bullet, idx) {
        const active = idx === slide;
        if (active) {
          bullet.classList.add('keen-slider__bullet--active');
          bullet.removeAttribute('tabindex');    
        } else {
          bullet.classList.remove('keen-slider__bullet--active');
          bullet.setAttribute('tabindex', '-1');
        }
        bullet.setAttribute('aria-selected', active.toString());
      });
      // may update focus:
      if (bulletsList && bulletsList.contains(document.activeElement)) {
        const activeBullet = bulletsList.querySelector('.keen-slider__bullet--active');
        if (activeBullet) {
          activeBullet.focus();
        }
      }
    };
    slider.on('created', updateClasses);
    slider.on('optionsChanged', updateClasses);
    slider.on('slideChanged', updateClasses);
  },
  Keyboard: (slider) => {
    const wrapper = getWrapper(slider);
    // check if slider has bullets:
    const bullets = wrapper.querySelector('.keen-slider__bullets-list');
    function eventKeydown(e) {
      switch (e.key) {
        default:
          break;
        case 'Left':
        case 'ArrowLeft':
          slider.prev();
          break;
        case 'Right':
        case 'ArrowRight':
          slider.next();
          break;
      }
    }
    slider.on('created', () => {
      if (bullets) {
        bullets.addEventListener('keydown', eventKeydown);
      } else {
        wrapper.addEventListener('keydown', eventKeydown);
      }
    });
  },
  AutoPlay: (duration = 2000, pauseOnHover = false, pauseOnFocus = true) => {
    return (slider) => {
      const wrapper = getWrapper(slider);
      slider.paused = false;
      let timeout;
      let mouseOver = false;
      const clearNextTimeout = () => {
        clearTimeout(timeout);
      };
      const nextTimeout = () => {
        clearTimeout(timeout);
        if (mouseOver || slider.paused) return;
        timeout = setTimeout(() => {
          slider.next();
        }, duration);
      };
      slider.pause = () => {
        slider.paused = true;
        slider.emit('pause');
        clearNextTimeout();
      }
      slider.play = () => {
        slider.paused = false;
        slider.emit('play');
        nextTimeout();
      }
      slider.on('created', () => {
        if (pauseOnHover) {
          wrapper.addEventListener('mouseover', () => {
            mouseOver = true;
            clearNextTimeout();
          });
          wrapper.addEventListener('mouseout', () => {
            mouseOver = false;
            nextTimeout();
          });
        }
        if (pauseOnFocus) {
          wrapper.addEventListener('focusin', () => {
            slider.pause();
          });
        }
        nextTimeout();
      });
      slider.on('dragStarted', clearNextTimeout);
      slider.on('animationEnded', nextTimeout);
      slider.on('updated', nextTimeout);
    };
  },
  Lazy: ({lazyPreloadNext} = {lazyPreloadNext: 0}) => {
    const lazyScrollThreshold = 0.2;
    let inView = false;
    let intersectionObserver = null;

    return (slider) => {
      const loadImage = (image) => {
        if (image.dataset.keenSrc || image.dataset.keenSrcset) {
          if (image.dataset.keenSrcset) {
            image.srcset = image.dataset.keenSrcset;
            image.removeAttribute('data-keen-srcset');
          }
          if (image.dataset.keenSrc) {
            image.src = image.dataset.keenSrc;
            image.removeAttribute('data-keen-src');
          }
          image.classList.remove('keen-slider__lazy');
        }
      };
      const lazyLoadImages = () => {
        if (!inView) return;
        const additionalSlides = lazyPreloadNext;
        const slides = slider.slides;
        const rel = slider.track.details.rel;
        for (let i = rel; i <= rel + additionalSlides; i++) {
          const imgs =
            slides[i % slides.length].querySelectorAll('.keen-slider__lazy');
          imgs.forEach((img) => loadImage(img));
        }
      };
      const initLazyLoad = () => {
        if (inView) return;
        inView = true;
        lazyLoadImages();
        slider.on('slideChanged', lazyLoadImages);
        slider.on('optionsChanged', lazyLoadImages);
      };

      slider.on('created', () => {
        intersectionObserver = new window.IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              initLazyLoad();
              intersectionObserver.disconnect();
              intersectionObserver = null;
              return;
            }
          },
          {root: null, threshold: lazyScrollThreshold},
        );
        intersectionObserver.observe(slider.container);
      });
      slider.on('destroyed', () => {
        if (intersectionObserver) {
          intersectionObserver.disconnect();
          intersectionObserver = null;
        }
      });
    };
  },
  Accessibility: (slider) => {
    if (!slider || !slider.container) return;
    function focusInVisibleSlide() {
      let focusSet = false;
      slider.slides.forEach((slide, idx) => { 
        if (focusSet || !slider.track || !slider.track.details) return;
        const portion = slider.track.details.slides[idx]?.portion || 0;
        const visible = portion > 0.3;
        if (visible) {
          const nextFocus = slide.querySelector('[href], button');
          if (nextFocus) {
            nextFocus.focus();
            focusSet = true;
          }
        }
      });
    }
    slider.on('detailsChanged', () => {
      if (!slider.track || !slider.track.details) return;
      slider.slides.forEach((slide, idx) => { 
        const portion = slider.track.details.slides[idx]?.portion || 0;
        const visible = portion > 0.3;
        if (!visible) {
          // check if element had focus and is now hidden:
          if (slide.contains(document.activeElement)) {
            // select the next visible slide:
            focusInVisibleSlide();
          }

          slide.setAttribute('inert', '');
          
        } else {
          slide.removeAttribute('inert');
        }
      });
    });
  },
};